export default function Leave(extendLeaveModel, Restangular, EventCollection, dateFilter) {
  'ngInject';

  function _transformModel(model) {
    if (model.users) {
      if (model.users.length) {
        model.user = model.users[0];
        model.userId = model.users[0].id;
      } else {
        model.user = null;
        model.userId = 0;
      }

      delete model.users;
    }

    // Send timezone-less times!
    model.dtstart = dateFilter(
      model.fullDay && model.fullDayDtstart ? model.fullDayDtstart : model.dtstart,
      'yyyy-MM-ddTHH:mm'
    );
    model.dtend = dateFilter(
      model.fullDay && model.fullDayDtstart ? model.fullDayDtend : model.dtend,
      'yyyy-MM-ddTHH:mm'
    );

    return model;
  }

  Restangular.addRequestInterceptor((element, operation, what) => {
    let returnElement = element;
    if (what === 'leave') {
      if (operation === 'post' || operation === 'put') {
        returnElement = _transformModel({ ...element });
      }

      // Do NOT send a payload for the DELETE, see https://github.com/getsling/sling-server/issues/1369
      if (operation === 'remove') {
        return null;
      }
    }

    return returnElement;
  });

  // Update EventCollection based on server response
  Restangular.addResponseInterceptor((data, operation, what) => {
    // console.log(operation, what);

    if (data && what === 'leave') {
      // there are no recurrent time offs
      delete data.rrule;

      if (operation === 'post' || operation === 'put') {
        EventCollection.addOrEditEvents([data]);
      }

      if (operation === 'remove') {
        EventCollection.deleteEvent(data);
      }
    }

    if (data?.type === 'leave' && (what === 'approve' || what === 'deny')) {
      if (operation === 'post') {
        EventCollection.addOrEditEvents([data]);
      }
    }

    return data;
  });

  return Restangular.service('leave');
}
